import React, { useEffect, useState } from "react";

import { closeModal, SweetAlertShow, LoadingDiv } from "../master/Master";

import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";

import usePrivateLink from "../config/usePrivateLink";

import Swal from "sweetalert2";

import {
  documentsTypeAdd,
  documentsTypeDelete,
  documentsTypeList,
  documentsTypeStatusChange,
  documentsTypeUpdate,
} from "../../api/CollectionDistribution";

import Pagination from "../components/Pagination";

export default function DocumentsType() {
  const hasAccess = usePrivateLink();

  const [modelData, setModelData] = useState({});
  const [loading, setLoading] = useState(false);
  const [data, setDocuments] = useState({});

  const [filters, setFilters] = useState({
    page: 1,
  });

  const [search, setSearch] = useState("");
  const [documentType, setDocumentType] = useState("");
  const [status, setStatus] = useState("");

  const editData = (item) => {
    setModelData(item);
  };

  // GET DOCUMENT TYPES
  const getDocuments = async () => {
    try {
      setLoading(true);

      let url = `?page=${filters.page}`;

      if (search) {
        url += `&search=${search}`;
      }

      if (documentType) {
        url += `&document_type=${documentType}`;
      }

      if (status) {
        url += `&status=${status}`;
      }

      const response = await documentsTypeList(url);

      if (response?.data?.status) {
        setDocuments(response?.data?.data);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDocuments();
  }, [search, documentType, status, filters.page]);

  // ADD
  const handleAdd = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const formData = new FormData(e.target);

      const response = await documentsTypeAdd(formData);

      if (response?.data?.status) {
        e.target.reset();

        closeModal("addCategory");

        SweetAlertShow("success", "Successfully", response?.data?.message);

        getDocuments();
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  // UPDATE
  const handleUpdate = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const formData = new FormData(e.target);

      const response = await documentsTypeUpdate(formData);

      if (response?.data?.status) {
        closeModal("updateCategory");

        SweetAlertShow("success", "Successfully", response?.data?.message);

        getDocuments();
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  // DELETE
  const handleDelete = async (id) => {
    try {
      const confirm = await Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this document!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete",
      });

      if (confirm.isConfirmed) {
        setLoading(true);

        const response = await documentsTypeDelete(id);

        if (response?.data?.status) {
          SweetAlertShow("success", "Success", response?.data?.message);

          getDocuments();
        }
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  // STATUS
  const handleStatusChange = async (id) => {
    try {
      setLoading(true);

      const response = await documentsTypeStatusChange(id);

      if (response?.data?.status) {
        SweetAlertShow("success", "Success", response?.data?.message);

        getDocuments();
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const clearFilters = () => {
    setSearch("");
    setDocumentType("");
    setStatus("");

    setFilters({
      page: 1,
    });
  };

  const hasFilters = search || documentType || status;

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />

                  {/* PAGE HEADER */}
                  <div className="col-12 mb-4">
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                          <div className="d-flex align-items-center gap-3">
                            <div
                              className="avatar avatar-lg"
                              style={{
                                width: "52px",
                                height: "52px",
                              }}
                            >
                              <span className="avatar-initial rounded bg-label-primary">
                                <i className="ri-file-list-3-line fs-3"></i>
                              </span>
                            </div>

                            <div>
                              <h4 className="mb-1">Document Types</h4>

                              <p className="text-muted mb-0">
                                Manage and organize required document categories
                              </p>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <span className="badge rounded-pill bg-label-info px-3 py-2">
                              <i className="ri-file-list-line me-1"></i>
                              {data?.total ?? 0} Types
                            </span>

                            {hasAccess(
                              "/collections/distribution/category/add",
                            ) && (
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  data-bs-toggle="modal"
                                  data-bs-target="#addCategory"
                                >
                                  <i className="ri-add-line me-1"></i>
                                  Add Type
                                </button>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* FILTER CARD */}
                  <div className="col-12 mb-4">
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
                          <div>
                            <h6 className="mb-1">Search & Filters</h6>

                            <small className="text-muted">
                              Find document types by name, category or status
                            </small>
                          </div>

                          {hasFilters && (
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-secondary"
                              onClick={clearFilters}
                            >
                              <i className="ri-close-circle-line me-1"></i>
                              Clear Filters
                            </button>
                          )}
                        </div>

                        <div className="row g-3">
                          {/* SEARCH */}
                          <div className="col-lg-5 col-md-6">
                            <label className="form-label">Search</label>

                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-search-line"></i>
                              </span>

                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search document name..."
                                value={search}
                                onChange={(e) => {
                                  setSearch(e.target.value);

                                  setFilters((prev) => ({
                                    ...prev,
                                    page: 1,
                                  }));
                                }}
                              />

                              {search && (
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary"
                                  onClick={() => {
                                    setSearch("");

                                    setFilters((prev) => ({
                                      ...prev,
                                      page: 1,
                                    }));
                                  }}
                                  title="Clear search"
                                >
                                  <i className="ri-close-line"></i>
                                </button>
                              )}
                            </div>
                          </div>

                          {/* DOCUMENT TYPE */}
                          <div className="col-lg-3 col-md-3">
                            <label className="form-label">Document Type</label>

                            <select
                              className="form-select"
                              value={documentType}
                              onChange={(e) => {
                                setDocumentType(e.target.value);

                                setFilters((prev) => ({
                                  ...prev,
                                  page: 1,
                                }));
                              }}
                            >
                              <option value="">All Types</option>

                              <option value="Identity">
                                Identity Document
                              </option>

                              <option value="Marksheet">Marksheet</option>

                              <option value="Other">Other Document</option>
                            </select>
                          </div>

                          {/* STATUS */}
                          <div className="col-lg-2 col-md-3">
                            <label className="form-label">Status</label>

                            <select
                              className="form-select"
                              value={status}
                              onChange={(e) => {
                                setStatus(e.target.value);

                                setFilters((prev) => ({
                                  ...prev,
                                  page: 1,
                                }));
                              }}
                            >
                              <option value="">All Status</option>

                              <option value="1">Active</option>

                              <option value="0">Inactive</option>
                            </select>
                          </div>

                          {/* RESULT COUNT */}
                          <div className="col-lg-2 d-flex align-items-end">
                            <div className="border rounded w-100 px-3 py-2">
                              <small className="text-muted d-block">
                                Results
                              </small>

                              <span className="fw-semibold">
                                {data?.total ?? 0} document types
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* TABLE CARD */}
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header border-bottom">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                          <div>
                            <h5 className="mb-1">Document Type List</h5>

                            <small className="text-muted">
                              Configure the document categories available in the
                              system
                            </small>
                          </div>

                          <span className="badge rounded-pill bg-label-primary px-3 py-2">
                            <i className="ri-file-list-2-line me-1"></i>
                            {data?.data?.length ?? 0} Showing
                          </span>
                        </div>
                      </div>

                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table table-hover align-middle mb-0">
                            <thead className="table-light">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "70px" }}
                                >
                                  #
                                </th>

                                <th>Document Name</th>

                                <th style={{ width: "200px" }}>Type</th>

                                <th style={{ width: "190px" }}>Status</th>

                                <th
                                  className="text-center"
                                  style={{ width: "130px" }}
                                >
                                  Actions
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {data?.data?.length > 0 ? (
                                data.data.map((item, index) => (
                                  <tr key={item.id}>
                                    {/* NUMBER */}
                                    <td className="text-center">
                                      <span className="text-muted fw-medium">
                                        {(data.current_page - 1) *
                                          data.per_page +
                                          index +
                                          1}
                                      </span>
                                    </td>

                                    {/* NAME */}
                                    <td>
                                      <div className="d-flex align-items-center gap-3">
                                        <div
                                          className="avatar avatar-sm"
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                          }}
                                        >
                                          <span className="avatar-initial rounded bg-label-primary">
                                            <i className="ri-file-text-line"></i>
                                          </span>
                                        </div>

                                        <div>
                                          <h6 className="mb-1">
                                            {item.document_name}
                                          </h6>
                                        </div>
                                      </div>
                                    </td>

                                    {/* TYPE */}
                                    <td>
                                      <span className="badge rounded-pill bg-label-info px-3 py-2">
                                        <i className="ri-price-tag-3-line me-1"></i>
                                        {item.document_type}
                                      </span>
                                    </td>

                                    {/* STATUS */}
                                    <td>

                                      <div className="d-flex align-items-center gap-3">
                                        <div>
                                          <span
                                            className={`badge rounded-pill ${item.status === "1"
                                              ? "bg-success"
                                              : "bg-secondary"
                                              }`}
                                          >
                                            <i
                                              className={`${item.status === "1"
                                                ? "ri-checkbox-circle-line"
                                                : "ri-close-circle-line"
                                                } me-1`}
                                            ></i>

                                            {item.status === "1"
                                              ? "Active"
                                              : "Inactive"}
                                          </span>
                                        </div>
                                        {hasAccess("/document/type/status") && (
                                          <div className="form-check form-switch m-0">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              role="switch"
                                              checked={item.status === "1"}
                                              onChange={() =>
                                                handleStatusChange(item.id)
                                              }
                                            />
                                          </div>
                                        )}
                                      </div>

                                    </td>

                                    {/* ACTIONS */}
                                    <td className="text-center">
                                      <div className="d-flex justify-content-center gap-2">
                                        {hasAccess("/document/type/edit") && (
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            data-bs-toggle="modal"
                                            data-bs-target="#updateCategory"
                                            onClick={() => editData(item)}
                                            title="Edit"
                                          >
                                            <i className="ri-edit-line"></i>
                                          </button>
                                        )}
                                        {hasAccess("/document/type/delete") && (
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => handleDelete(item.id)}
                                            title="Delete"
                                          >
                                            <i className="ri-delete-bin-line"></i>
                                          </button>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="5">
                                    <div className="card border-0 shadow-none mb-0">
                                      <div className="card-body text-center py-5">
                                        <div
                                          className="avatar avatar-xl mx-auto mb-3"
                                          style={{
                                            width: "70px",
                                            height: "70px",
                                          }}
                                        >
                                          <span className="avatar-initial rounded-circle bg-label-secondary">
                                            <i className="ri-file-list-3-line fs-2"></i>
                                          </span>
                                        </div>

                                        <h5 className="mb-2">
                                          No Document Types Found
                                        </h5>

                                        <p className="text-muted mb-3">
                                          {hasFilters
                                            ? "No document types match the selected filters."
                                            : "There are no document types available yet."}
                                        </p>

                                        {hasFilters ? (
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={clearFilters}
                                          >
                                            <i className="ri-refresh-line me-1"></i>
                                            Clear Filters
                                          </button>
                                        ) : (
                                          hasAccess(
                                            "/collections/distribution/category/add",
                                          ) && (
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-primary"
                                              data-bs-toggle="modal"
                                              data-bs-target="#addCategory"
                                            >
                                              <i className="ri-add-line me-1"></i>
                                              Add Document Type
                                            </button>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* PAGINATION */}
                      {data?.data?.length > 0 && (
                        <div className="card-footer border-top">
                          <Pagination
                            data={data}
                            setFilters={setFilters}
                            filters={filters}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =========================================================
          ADD DOCUMENT TYPE MODAL
      ========================================================= */}
      <div
        className="modal fade"
        id="addCategory"
        tabIndex="-1"
        aria-labelledby="addCategoryLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleAdd}>
              <div className="modal-header">
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="avatar avatar-sm"
                    style={{
                      width: "40px",
                      height: "40px",
                    }}
                  >
                    <span className="avatar-initial rounded bg-label-primary">
                      <i className="ri-add-line fs-5"></i>
                    </span>
                  </div>

                  <div>
                    <h5 className="modal-title mb-1" id="addCategoryLabel">
                      Add Document Type
                    </h5>

                    <small className="text-muted">
                      Create a new document category
                    </small>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="document_name" className="form-label">
                    Document Name
                  </label>

                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-file-text-line"></i>
                    </span>

                    <input
                      type="text"
                      className="form-control input-uppercase"
                      name="document_name"
                      id="document_name"
                      placeholder="Enter document name"
                      required
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="document_type" className="form-label">
                    Document Type
                  </label>

                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-price-tag-3-line"></i>
                    </span>

                    <select
                      className="form-select"
                      name="document_type"
                      id="document_type"
                      required
                      defaultValue=""
                    >
                      <option value="" disabled>
                        Select document type
                      </option>

                      <option value="Identity">Identity Document</option>

                      <option value="Marksheet">Marksheet</option>

                      <option value="Other">Other Document</option>
                    </select>
                  </div>
                </div>

                <div className="alert alert-info d-flex align-items-start gap-2 mb-0">
                  <i className="ri-information-line fs-5"></i>

                  <small>
                    Select the category that best describes the document being
                    collected.
                  </small>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  <i className="ri-save-line me-1"></i>

                  {loading ? "Submitting..." : "Save Document Type"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* =========================================================
          UPDATE DOCUMENT TYPE MODAL
      ========================================================= */}
      <div
        className="modal fade"
        id="updateCategory"
        tabIndex="-1"
        aria-labelledby="updateCategoryLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleUpdate}>
              <input type="hidden" name="id" value={modelData?.id || ""} />

              <div className="modal-header">
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="avatar avatar-sm"
                    style={{
                      width: "40px",
                      height: "40px",
                    }}
                  >
                    <span className="avatar-initial rounded bg-label-primary">
                      <i className="ri-edit-line fs-5"></i>
                    </span>
                  </div>

                  <div>
                    <h5 className="modal-title mb-1" id="updateCategoryLabel">
                      Update Document Type
                    </h5>

                    <small className="text-muted">
                      Modify document category details
                    </small>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="update_document_name" className="form-label">
                    Document Name
                  </label>

                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-file-text-line"></i>
                    </span>

                    <input
                      type="text"
                      className="form-control input-uppercase"
                      name="document_name"
                      id="update_document_name"
                      placeholder="Enter document name"
                      defaultValue={modelData?.document_name || ""}
                      required
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="update_document_type" className="form-label">
                    Document Type
                  </label>

                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-price-tag-3-line"></i>
                    </span>

                    <select
                      className="form-select"
                      name="document_type"
                      id="update_document_type"
                      required
                      value={modelData?.document_type || ""}
                      onChange={(e) =>
                        setModelData((prev) => ({
                          ...prev,
                          document_type: e.target.value,
                        }))
                      }
                    >
                      <option value="" disabled>
                        Select document type
                      </option>

                      <option value="Identity">Identity Document</option>

                      <option value="Marksheet">Marksheet</option>

                      <option value="Other">Other Document</option>
                    </select>
                  </div>
                </div>

                <div className="alert alert-info d-flex align-items-start gap-2 mb-0">
                  <i className="ri-information-line fs-5"></i>

                  <small>
                    Updating this type will affect how the document category is
                    displayed throughout the system.
                  </small>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  <i className="ri-save-line me-1"></i>

                  {loading ? "Updating..." : "Update Document Type"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
